import {
    CHANGE_VIEW_TYPE,
    RESET_SORT_MENU,
    SHOW_SORT_MENU,
    HIDE_SORT_MENU,
    CHANGE_ORDERBY_TYPE,
    SET_ORDERBY_TYPES,
    SORTING_FILTERS_ENABLED,
    CHANGE_SELECT_TYPE,
    SORTING_ENABLED_OPTIONS,
    ADD_ACTIVE_FILTER,
    SET_ACTIVE_FILTERS,
    REMOVE_ACTIVE_FILTER,
    CLEAR_ACTIVE_FILTERS,
    SET_ORDER_BY_DIRECTION,
    SET_ORDER_BY_PROPERTY,
    SET_ACTION_MENU,
    SHOW_ORG_SELECT,
    SHOW_JIT_ORG_SELECT,
    SHOW_BULL_PHISH_ORG_SELECT
} from '@app/store/constants';
import { ISortMenuViewTypes, ISortMenuOrderbyTypes, IListPageBarEnabled, IActiveFilter, DispatchFunction, IDotMenu, OrderType } from '@app/models';
import { Dispatch } from 'redux';

export function handleSortingMenu(setListPageBarEnabledOptions: IListPageBarEnabled): DispatchFunction {
    return ((dispatch: Dispatch) => {
        dispatch(showSortingMenu());
        dispatch(sortingEnabledOptions(setListPageBarEnabledOptions));
    });
}

export function changeViewType(type: ISortMenuViewTypes) {
    return {
        payload: type,
        type: CHANGE_VIEW_TYPE,
    };
}

export function changeOrderbyType(type: ISortMenuOrderbyTypes) {
    return {
        payload: type,
        type: CHANGE_ORDERBY_TYPE,
    };
}

export function setOrderbyTypes(types: ISortMenuOrderbyTypes[]) {
    return {
        payload: types,
        type: SET_ORDERBY_TYPES,
    };
}

export function resetSortingMenu() {
    return {
        type: RESET_SORT_MENU,
    };
}

export function showSortingMenu() {
    return {
        type: SHOW_SORT_MENU
    };
}
export function showOrgSelect() {
    return {
        type: SHOW_ORG_SELECT
    };
}

export function showJitOrgSelect() {
    return {
        type: SHOW_JIT_ORG_SELECT
    };
}

export function showBullPhishOrgSelect() {
    return {
        type: SHOW_BULL_PHISH_ORG_SELECT
    };
}

export function hideSortingMenu() {
    return {
        type: HIDE_SORT_MENU
    };
}

export function sortingFiltersEnabled(toggle: boolean) {
    return {
        payload: toggle,
        type: SORTING_FILTERS_ENABLED
    };
}


export function changeSelectType(selectedData: string) {
    return {
        payload: selectedData,
        type: CHANGE_SELECT_TYPE
    };
}

export function sortingEnabledOptions(sortEnabled: IListPageBarEnabled) {
    return {
        payload: sortEnabled,
        type: SORTING_ENABLED_OPTIONS
    };
}

export function addActiveFilter(filter: IActiveFilter) {
    return {
        payload: filter,
        type: ADD_ACTIVE_FILTER
    };
}

export function setActiveFilters(filters: IActiveFilter[]) {
    return {
        payload: filters,
        type: SET_ACTIVE_FILTERS
    };
}

export function removeActiveFilter(filterName: string) {
    return {
        payload: filterName,
        type: REMOVE_ACTIVE_FILTER
    };
}

export function clearActiveFilters() {
    return {
        type: CLEAR_ACTIVE_FILTERS
    };
}

export function setOrderByDirection(direction: OrderType) {
    return {
        type: SET_ORDER_BY_DIRECTION,
        payload: direction
    };
}

export function setOrderByProperty(property: string) {
    return {
        type: SET_ORDER_BY_PROPERTY,
        payload: property
    };
}

export function setActionMenuItems(items: IDotMenu[]) {
    return {
        payload: items,
        type: SET_ACTION_MENU
    };
}
